import _ from 'lodash'
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label
} from 'recharts'
import { Loader } from '@vzmi/shp_shared_compo'
import { NoData } from '../../../../Common/StatePage'
import ReactResizeDetector from 'react-resize-detector'
import { dollarFormat, numeralFormat } from '../../../../../../lib/renderUtil'
import { calcMaxDomain } from '../../../utils/chartUtil'
import CustomizeXAxisTick from './CustomizeXAxisTick'
import { useChartSizing } from '../../hooks/useChartSizing'
import YAxisTick from '../../../../Common/NewDashboard/Chart/YAxisTick/YAxisTick'
import CustomizedLegend from '../../../../Common/NewDashboard/Chart/Legend/Legend'
import YAxisLabel from '../../../../Common/NewDashboard/Chart/YAxisLabel/YAxisLabel'
import LineDot from '../../../../Common/NewDashboard/Chart/LineDot/LineDot'
import SalesPerformanceTooltip from './SalesPerformanceTooltip'
import styles from './PerformanceChart.css'

export const FIELD = {
  REPORT_DATE: 'reportDate',
  AMOUNT: 'amount',
  SOLD_QUANTITY: 'soldQuantity'
}

const PerformanceChart = ({ data, isLoading }) => {
  const {
    barSize,
    tooltipCursorWidth,
    initChart,
    updateBarAndCursorWidth
  } = useChartSizing(data)

  if (_.isEmpty(data)) {
    return <NoData iconType='history' />
  }

  return (
    <Loader loaded={!isLoading}>
      <div className={styles.chartBlock}>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={updateBarAndCursorWidth}
        />
        <ResponsiveContainer
          width='100%'
          height='100%'
          minHeight='250px'
        >
          <ComposedChart
            ref={initChart}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <XAxis
              tickLine={false}
              dataKey={FIELD.REPORT_DATE}
              tick={<CustomizeXAxisTick />}
              interval={1}
            />
            <YAxis
              yAxisId='left'
              axisLine={false}
              tickLine={false}
              tick={(
                <YAxisTick
                  prefix='$'
                  customizeTickValue={dollarFormat}
                  textAnchor='end'
                />
              )}
            >
              <Label
                value='金額'
                offset={20}
                position='left'
                angle={-90}
                content={<YAxisLabel />}
              />
            </YAxis>
            <YAxis
              yAxisId='right'
              orientation='right'
              axisLine={false}
              tickLine={false}
              domain={[0, calcMaxDomain()]}
              tick={(
                <YAxisTick
                  customizeTickValue={value => numeralFormat(value, { allowZero: true })}
                  textAnchor='start'
                />
              )}
              allowDecimals
            >
              <Label
                value='數量'
                offset={20}
                position='right'
                angle={90}
                content={<YAxisLabel />}
              />
            </YAxis>
            <CartesianGrid
              vertical={false}
              stroke='#f5f5f5'
            />
            <Tooltip
              cursor={{
                stroke: '#eee',
                strokeWidth: tooltipCursorWidth
              }}
              position={{ y: -80 }}
              wrapperStyle={{ zIndex: 1 }}
              content={<SalesPerformanceTooltip/>}
            />
            <Legend
              align='left'
              verticalAlign='top'
              wrapperStyle={{
                top: '-40px',
                color: '#9aa0ab'
              }}
              content={<CustomizedLegend />}
            />
            <Bar
              name='訂購金額'
              yAxisId='left'
              dataKey={FIELD.AMOUNT}
              legendType='square'
              fill='#6a96f3'
              barSize={barSize}
            />
            <Line
              name='訂購量'
              yAxisId='right'
              dataKey={FIELD.SOLD_QUANTITY}
              stroke='#7dd5a9'
              strokeWidth='2'
              activeDot={false}
              dot={<LineDot />}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Loader>
  )
}

export default PerformanceChart
